export const genres = [
  { _id: 1, name: "Action" },
  { _id: 2, name: "Comedy" },
  { _id: 3, name: "Thriller" },
  { _id: 4, name: "Fantasy" },
  { _id: 5, name: "science fiction" }
];

export function getGenres() {
  return genres.filter((g) => g);
}
